/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Estimatedcost1Inputs */

const zh_analytics_estimatedcost1 = /** @type {(inputs: Analytics_Estimatedcost1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预估费用`)
};

const en_analytics_estimatedcost1 = /** @type {(inputs: Analytics_Estimatedcost1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated Cost`)
};

const es_analytics_estimatedcost1 = /** @type {(inputs: Analytics_Estimatedcost1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo estimado`)
};

/**
* | output |
* | --- |
* | "Estimated Cost" |
*
* @param {Analytics_Estimatedcost1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_estimatedcost1 = /** @type {((inputs?: Analytics_Estimatedcost1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Estimatedcost1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_estimatedcost1(inputs)
	if (locale === "en") return en_analytics_estimatedcost1(inputs)
	return es_analytics_estimatedcost1(inputs)
});
export { analytics_estimatedcost1 as "analytics_estimatedCost" }